import * as React from 'react';
import { RouteComponentProps, Prompt } from 'react-router-dom';
import { Input } from '@progress/kendo-react-inputs';
import { MultiSelect, MultiSelectFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import { FilterDescriptor, filterBy } from '@progress/kendo-data-query';
import { Notification } from '@progress/kendo-react-notification';
import { Fade } from '@progress/kendo-react-animation';
import LoadingPanel from '../LoadingPanel';
import { fetchApi } from '../../services/api';
import { IDName } from '../Accounts/Payments';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{ documentId: string }>;

type State = {
    isLoading: boolean;
    isSaved: boolean;
    isDirty: boolean;
    document: DocumentData | undefined;
    accounts: IDName[];
    children: IDName[];
    teachers: IDName[];
    schools: IDName[];
    courses: IDName[];
    instructors: IDName[];
    grades: IDName[];
    documentTypes: IDName[];
    units: IDName[];

    accountsFilter: FilterDescriptor;
    childrenFilter: FilterDescriptor;
    teachersFilter: FilterDescriptor;
    schoolsFilter: FilterDescriptor;
    coursesFilter: FilterDescriptor;
    instructorsFilter: FilterDescriptor;
    gradesFilter: FilterDescriptor;
    documentTypeFilter: FilterDescriptor;
    unitFilter: FilterDescriptor;
}

type DocumentData = {
    DocumentID: number;
    Title: string;
    Description: string;
    AcademicUser: boolean;
    IsDocx: boolean;
    Accounts: number[];
    Children: number[];
    Teachers: number[];
    Schools: number[];
    Courses: number[];
    Instructors: number[];
    Grades: number[];
    DocumentTypes: number[];
    Units: number[];
}

export default class Edit extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: true,
            isSaved: false,
            isDirty: false,
            accounts: [],
            children: [],
            teachers: [],
            schools: [],
            courses: [],
            instructors: [],
            grades: [],
            documentTypes: [],
            units: [],
            document: undefined,

            accountsFilter: undefined,
            childrenFilter: undefined,
            teachersFilter: undefined,
            schoolsFilter: undefined,
            coursesFilter: undefined,
            instructorsFilter: undefined,
            gradesFilter: undefined,
            documentTypeFilter: undefined,
            unitFilter: undefined,
        }

        this.save = this.save.bind(this);
        this.delete = this.delete.bind(this);
        this.updateDocument = this.updateDocument.bind(this);
        this.accountsFilterChange = this.accountsFilterChange.bind(this);
        this.childrenFilterChange = this.childrenFilterChange.bind(this);
        this.teachersFilterChange = this.teachersFilterChange.bind(this);
        this.schoolsFilterChange = this.schoolsFilterChange.bind(this);
        this.coursesFilterChange = this.coursesFilterChange.bind(this);
        this.documentTypeFilterChange = this.documentTypeFilterChange.bind(this);
        this.unitFilterChange = this.unitFilterChange.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let documentId = parseInt(this.props.match.params.documentId) || 0;
        this.requestDocument(documentId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let documentId = parseInt(nextProps.match.params.documentId) || 0;

        if (this.state.document && this.state.document.DocumentID != documentId) {
            this.requestDocument(documentId);
        }
    }

    public render() {
        return <React.Fragment>
            <br />
            <div className="row">
                <div className="col">
                    <h1>Edit Document</h1>
                </div>
                {this.state.document && <div className="col text-right">
                    <a className="btn btn-primary" href={`/api/Document/Download/${this.state.document.DocumentID}/${localStorage.getItem('ACCESS_TOKEN')}`} download>Download/Print</a>
                </div>}
            </div>
            <DocumentTitle title="Edit Document" />
            <Prompt when={this.state.isDirty} message="Unsaved changes will be lost, are you sure?" />
            {!this.state.document && <LoadingPanel />}
            {this.state.document && <div className="row">
                <div className="col-xl-3">
                    <Fade enter={true}>
                        {this.state.isSaved && <Notification
                            closable={true}
                            type={{ style: 'success', icon: true }}
                            onClose={() => this.setState({ isSaved: false })}
                        >
                            <span>Document updated succssfully.</span>
                        </Notification>}
                    </Fade>
                    {this.state.isLoading && <p>Saving...</p>}
                    {!this.state.isLoading && <form onSubmit={this.save}>
                        <Input
                            required
                            label="Title"
                            value={this.state.document.Title}
                            onChange={(e) => this.updateDocument({ Title: e.target.value })}
                            style={{ width: "100%" }}
                        />
                        <textarea
                            placeholder="Description"
                            className="k-textarea"
                            value={this.state.document.Description}
                            onChange={(e) => this.updateDocument({ Description: e.target.value })}
                            style={{ width: "100%", marginTop: 10, marginBottom: 10  }}
                        />
                        <MultiSelect
                            label="Accounts"
                            textField="Name"
                            filterable={true}
                            onFilterChange={this.accountsFilterChange}
                            data={filterBy(this.state.accounts, this.state.accountsFilter)}
                            value={this.state.accounts.filter(x => this.state.document.Accounts.includes(x.ID))}
                            onChange={(e) => this.updateDocument({ Accounts: e.target.value.map(x => x.ID) })}
                            style={{ width: "100%" }}
                        />
                        <MultiSelect
                            label="Children"
                            textField="Name"
                            filterable={true}
                            onFilterChange={this.childrenFilterChange}
                            data={filterBy(this.state.children, this.state.childrenFilter)}
                            value={this.state.children.filter(x => this.state.document.Children.includes(x.ID))}
                            onChange={(e) => this.updateDocument({ Children: e.target.value.map(x => x.ID) })}
                            style={{ width: "100%" }}
                        />
                        <MultiSelect
                            label="Instructors"
                            textField="Name"
                            filterable={true}
                            onFilterChange={this.instructorsFilterChange}
                            data={filterBy(this.state.instructors, this.state.instructorsFilter)}
                            value={this.state.instructors.filter(x => this.state.document.Instructors.includes(x.ID))}
                            onChange={(e) => this.updateDocument({ Instructors: e.target.value.map(x => x.ID)})}
                            style={{ width: "100%" }}
                        />
                        <MultiSelect
                            label="Document Type"
                            textField="Name"
                            filterable={true}
                            onFilterChange={this.documentTypeFilterChange}
                            data={filterBy(this.state.documentTypes, this.state.documentTypeFilter)}
                            value={this.state.documentTypes.filter(x => this.state.document.DocumentTypes.includes(x.ID))}
                            onChange={(e) => this.updateDocument({ DocumentTypes: e.target.value.map(x => x.ID)})}
                            style={{ width: "100%" }}
                        />
                        {this.state.document.AcademicUser && <React.Fragment>
                            <MultiSelect
                                label="Teachers"
                                textField="Name"
                                filterable={true}
                                onFilterChange={this.teachersFilterChange}
                                data={filterBy(this.state.teachers, this.state.teachersFilter)}
                                value={this.state.teachers.filter(x => this.state.document.Teachers.includes(x.ID))}
                                onChange={(e) => this.updateDocument({ Teachers: e.target.value.map(x => x.ID) })}
                                style={{ width: "100%" }}
                            />
                            <MultiSelect
                                label="Schools"
                                textField="Name"
                                filterable={true}
                                onFilterChange={this.schoolsFilterChange}
                                data={filterBy(this.state.schools, this.state.schoolsFilter)}
                                value={this.state.schools.filter(x => this.state.document.Schools.includes(x.ID))}
                                onChange={(e) => this.updateDocument({ Schools: e.target.value.map(x => x.ID) })}
                                style={{ width: "100%" }}
                            />
                            <MultiSelect
                                label="Grade Level"
                                textField="Name"
                                filterable={true}
                                onFilterChange={this.gradeFilterChange}
                                data={filterBy(this.state.grades, this.state.gradesFilter)}
                                value={this.state.grades.filter(x => this.state.document.Grades.includes(x.ID))}
                                onChange={(e) => this.updateDocument({ Grades: e.target.value.map(x => x.ID)})}
                                style={{ width: "100%" }}
                            />
                            <MultiSelect
                                label="Courses"
                                textField="Name"
                                filterable={true}
                                onFilterChange={this.coursesFilterChange}
                                data={filterBy(this.state.courses, this.state.coursesFilter)}
                                value={this.state.courses.filter(x => this.state.document.Courses.includes(x.ID))}
                                onChange={(e) => this.updateDocument({ Courses: e.target.value.map(x => x.ID)})}
                                style={{ width: "100%" }}
                            />
                            <MultiSelect
                                label="Unit"
                                textField="Name"
                                filterable={true}
                                onFilterChange={this.unitFilterChange}
                                data={filterBy(this.state.units, this.state.unitFilter)}
                                value={this.state.units.filter(x => this.state.document.Units.includes(x.ID))}
                                onChange={(e) => this.updateDocument({ Units: e.target.value.map(x => x.ID)})}
                                style={{ width: "100%" }}
                            />
                        </React.Fragment>}
                        <br /><br />
                        <button type="submit" disabled={!this.state.isDirty} className="btn btn-primary">Save</button>
                        <button type="button" className="btn btn-danger float-right" onClick={this.delete}>Delete</button>
                    </form>}
                </div>
                {!this.state.document.IsDocx && <React.Fragment>
                    <div className="col-xl-9">
                        <embed src={`/api/Document/View/${this.state.document.DocumentID}/${localStorage.getItem('ACCESS_TOKEN')}`} width="100%" height={window.innerHeight} />
                    </div>
                </React.Fragment>}
            </div>}
            <br />
        </React.Fragment>;
    }

    private requestDocument(documentId: number) {
        this.setState({ isLoading: true });
        fetchApi(`/api/Document/View/${documentId}`)
            .then((response: DocumentData & {
                AccountsData: IDName[],
                ChildrenData: IDName[],
                TeachersData: IDName[],
                SchoolsData: IDName[],
                CoursesData: IDName[],
                InstructorsData: IDName[],
                GradesData: IDName[],
                DocumentTypesData: IDName[],
                UnitData: IDName[]
            }) => {
                const {
                    AccountsData,
                    ChildrenData,
                    TeachersData,
                    SchoolsData,
                    CoursesData,
                    InstructorsData,
                    GradesData,
                    DocumentTypesData,
                    UnitData,
                    ...document } = response;

                // New Upload
                if (!response.Title && this.props.location.state) {
                    document.Title = this.props.location.state.filename;
                    if (this.props.location.state.accountId) {
                        document.Accounts = [this.props.location.state.accountId, ...document.Accounts];
                    }
                    if (this.props.location.state.childId) {
                        document.Children = [this.props.location.state.childId, ...document.Children];
                    }
                }
                this.setState({
                    document,
                    isDirty: false,
                    accounts: AccountsData,
                    children: ChildrenData,
                    teachers: TeachersData,
                    schools: SchoolsData,
                    courses: CoursesData,
                    instructors: InstructorsData,
                    grades: GradesData,
                    documentTypes: DocumentTypesData,
                    units: UnitData
                });
            })
            .finally(() => {
                this.setState({ isLoading: false });
            });
    }

    private updateDocument(value: Partial<DocumentData>) {
        const document = Object.assign({}, this.state.document, value);
        this.setState({ document, isDirty: true });
    }

    private accountsFilterChange(e: MultiSelectFilterChangeEvent) {
        this.setState({ accountsFilter: e.filter});
    }

    private childrenFilterChange(e: MultiSelectFilterChangeEvent) {
        this.setState({ childrenFilter: e.filter});
    }

    private teachersFilterChange(e: MultiSelectFilterChangeEvent) {
        this.setState({ teachersFilter: e.filter});
    }

    private schoolsFilterChange(e: MultiSelectFilterChangeEvent) {
        this.setState({ schoolsFilter: e.filter});
    }

    private coursesFilterChange(e: MultiSelectFilterChangeEvent) {
        this.setState({ coursesFilter: e.filter });
    }

    private instructorsFilterChange(e: MultiSelectFilterChangeEvent) {
        this.setState({ instructorsFilter: e.filter });
    }

    private gradeFilterChange(e: MultiSelectFilterChangeEvent) {
        this.setState({ gradesFilter: e.filter });
    }

    private documentTypeFilterChange(e: MultiSelectFilterChangeEvent) {
        this.setState({ documentTypeFilter: e.filter });
    }

    private unitFilterChange(e: MultiSelectFilterChangeEvent) {
        this.setState({ unitFilter: e.filter });
    }

    private save(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        this.setState({ isLoading: true, isSaved: false });
        fetchApi(`/api/Document/Edit/${this.state.document.DocumentID}`, this.state.document, 'POST')
            .then(() => {
                this.setState({ isSaved: true, isDirty: false });
            })
            .catch(() => {
                alert("Unknown Error Occurred Updating Document!");
            })
            .finally(() => {
                this.setState({ isLoading: false });
            });
    }

    private delete() {
        if (confirm(`Are you sure you want to delete this document?`)) {
            this.setState({ isLoading: true, isDirty: false });
            fetchApi(`/api/Document/Delete/${this.state.document.DocumentID}`, {}, 'DELETE')
                .then(() => {
                    this.props.history.goBack()
                })
                .catch(() => {
                    alert("Unknown Error Occurred Deleting Document!");
                })
                .finally(() => {
                    this.setState({ isLoading: false });
                });
        }
    }
}
